import React, {
  useState,
  forwardRef,
  useEffect,
} from "react";

import { get } from "../../../services/api";
import { dateFormat } from "../../../utils/date";
import AddContactLog from "./AddContactLog"

const ViewContactLog = forwardRef((props, ref) => {

  const [contactLogs, setContactLogs] = useState([]);
  useEffect(() => {
    if(props.contactPersonId){
      getLogs();
    }
  }, []);


  const getLogs = async() => {
    const response = await get('/api/contact-log/person/'+props.contactPersonId, props.token);
    setContactLogs(response);
  }


  return (
    <>
      <div className="card">
        <div className="card-body p-2">
          <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
            <div className="tbl-caption">
            <h4 className="heading mb-0">Contact Logs</h4>
              <div>
                  <button
                          className="btn btn-primary light btn-sm me-2"
                          onClick={() => {
                            props?.contactLogRef.current.showContactModal();
                          }}
                        >
                          <i className="fa fa-plus"></i> Add Contact
                        </button>
                
              </div>
            </div>
            <div id="user-tbl_wrapper" className="dataTables_wrapper no-footer">
              <table
                id="projects-tbl"
                className="table ItemsCheckboxSec dataTable no-footer mb-3 me-3"
              >
                <thead>
                  <tr>
                    <th>Action</th>
                    <th>Date</th>
                    <th>Duration</th>
                    <th>Subject</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {contactLogs?.length === 0 && <tr>
                    <td colSpan={5} >No records!</td>
                  </tr>}
                  {contactLogs?.length > 0 &&  contactLogs.map((item, index) => (
                    <tr key={index}>
                      
                      <td>{item.action}</td>
                      <td>{dateFormat(item?.date)}</td>
                      <td>{item.duration}</td>
                      <td>{item.subject}</td>
                      <td>
                        <textarea
                        disabled
                        className="form-control"
                        rows="2"
                        style={{ resize: "none" }}
                        title={item.details}
                      >
                        {item.details}
                      </textarea></td>
                      
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <AddContactLog
        ref={props.contactLogRef}
        Title="Add Contact Log"
        token={props.token}
        contactPersonId={props.contactPersonId}
        getLogs={getLogs}
      />
    </>
  );
});

export default ViewContactLog;
